export enum OrigemAcaoVendaEnum {
  INATIVOS= 'INATIVOS',
  STREET_VIEW = 'STREET_VIEW',
  CAPTADOS = 'CAPTADOS',
  POTENCIAIS_CLIENTES = 'POTENCIAIS_CLIENTES',
  VENDEDOR_EXTERNO = 'VENDEDOR_EXTERNO',
}
